module.exports = __webpack_public_path__ + "static/media/pdfPoliticaTratamiento.04b34fb8.pdf";